import { useContext, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { FloatingWindowsContext } from "src/base-components/FloatingWindow/context";
import { useFloatingWindowsActions } from "src/base-components/FloatingWindow/hooks";

export const TaskWindowManager: React.FC = () => {
  const { close } = useFloatingWindowsActions();
  const store = useContext(FloatingWindowsContext);
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get("tab") || "tasks";
  const prevTabRef = useRef(currentTab);

  useEffect(() => {
    if (prevTabRef.current !== currentTab) {
      // Close unpinned task windows when switching tabs
      if (store) {
        const currentWindows = store.getState().windows;
        Object.values(currentWindows).forEach((window) => {
          if (window.type === "cm-task" && !window.isPinned) {
            close(window.id);
          }
        });
      }
    }
    prevTabRef.current = currentTab;
  }, [currentTab, close, store]);

  return null;
};
